
















































































































































import { computed, defineComponent, getCurrentInstance, onMounted, ref } from "vue";
import ConfirmationModal from "@/components/Organisms/ConfirmationModal.vue";
import {
  BOA_HORA_CALENDAR_LOCALE,
  BOA_HORA_LOCAL,
  BOA_HORA_SPECIALTY,
  BOA_HORA_TIME_SLOTS,
  formatPersonName,
  readBoaHora,
  saveBoaHora,
  toIsoDate,
  upcomingWeekdays
} from "@/utils/programaBoaHora";

export default defineComponent({
  components: { ConfirmationModal },
  setup() {
    const context = getCurrentInstance().proxy;
    const termsCheck = ref(false);
    const displayTerms = ref(false);
    const scheduled = ref(false);
    const selectedDate = ref("");
    const selectedTime = ref("");
    const calendarAttributes = ref([{ key: "selected-date", highlight: true, dates: null }]);
    const availableDates = upcomingWeekdays();
    const timeSlots = BOA_HORA_TIME_SLOTS;
    const calendarLocale = BOA_HORA_CALENDAR_LOCALE;
    const theme = computed(() => context.$store.state.saude.theme);
    const local = BOA_HORA_LOCAL;
    const specialty = BOA_HORA_SPECIALTY;

    const beneficiaryName = computed(() => {
      const credentials = context.$store.state.saude.credentials || [];
      const titular = credentials.find(item => item.titular) || credentials[0];
      return formatPersonName(titular?.name || context.$store.state.saude.profileName) || "Beneficiário";
    });

    const beneficiaryOptions = computed(() => [{ value: beneficiaryName.value, label: beneficiaryName.value }]);
    const localOptions = [{ value: local, label: local }];
    const specialtyOptions = [{ value: specialty, label: specialty }];
    const disableButton = computed(() => !termsCheck.value || !selectedDate.value || !selectedTime.value);

    onMounted(() => {
      context.$root.$emit("hide-loading");
      const record = readBoaHora(context.$store.state.saude.vinculo);
      if (!record.joined || !record.dueDate) {
        context.$router.replace({ name: "programa_saude_2.boa_hora.acompanhamento" });
      }
    });

    const showTerms = () => {
      window.scrollTo(0, 0);
      displayTerms.value = true;
    };

    const hideTerms = () => {
      displayTerms.value = false;
    };

    const onDayClick = day => {
      if (!day?.date || day.isDisabled) return;
      selectedDate.value = toIsoDate(day.date);
      selectedTime.value = "";
      calendarAttributes.value = [{ key: "selected-date", highlight: true, dates: day.date }];
    };

    const onSubmit = () => {
      if (disableButton.value) return;
      saveBoaHora(context.$store.state.saude.vinculo, {
        joined: true,
        appointment: {
          isoDate: selectedDate.value,
          time: selectedTime.value,
          beneficiary: beneficiaryName.value,
          local,
          specialty
        }
      });
      scheduled.value = true;
    };

    const goHome = () => {
      context.$router.push({ path: "/" });
    };

    return {
      beneficiaryName,
      beneficiaryOptions,
      local,
      localOptions,
      specialty,
      specialtyOptions,
      calendarLocale,
      calendarAttributes,
      availableDates,
      timeSlots,
      selectedDate,
      selectedTime,
      termsCheck,
      displayTerms,
      theme,
      showTerms,
      hideTerms,
      scheduled,
      disableButton,
      onDayClick,
      onSubmit,
      goHome
    };
  }
});
